import React from 'react';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import { GalleryImageProps } from '../../models/GalleryWidgetModel';
import { CDNImage } from 'shared-widget-components/src/components/CDNImage/CDNImage';
interface SmallImagesProps {
  images: GalleryImageProps[];
  renderedImages: number;
  openImageViewer: (index: number) => void;
}
/**
 * @description This component displays the small images of the gallery in the preview as well as the Masonry Grid gallery in the Webshop
 * @param0 widgetState GalleryWidgetState; The data of the widget.
 * @param1 openImageViewer (index: number) => void; The function to call when the image viewer is opened.
 * @returns {JSX.Element} The SmallImages component
 */

export const SmallImages: React.FC<SmallImagesProps> = ({ images, renderedImages, openImageViewer }) => {
  return (
    <ResponsiveMasonry className=' min-[350px]:hidden md:block' columnsCountBreakPoints={{ 900: 3 }}>
      {/* Első x kép megjelenítése */}
      <Masonry>
        {images &&
          images

            // Csak azok a képek ahol van file name
            .filter((image) => image.fileName !== '' && image.fileName !== undefined)
            // Szűrés a megjelenítendő képek száma szerint
            .slice(0, Number(renderedImages) + 1)
            .map((image, imageIndex) => {
              return (
                <div key={imageIndex}>
                  <div className='relative flex justify-center w-[97%] my-1 cursor-pointer' onClick={() => openImageViewer(imageIndex)}>
                    <CDNImage src={image.url!} imageWidth={400} fit='crop' className='rounded-md transition-transform transform hover:scale-105' alt={image.alt} />
                    {imageIndex === Number(renderedImages) && (
                      <div className='absolute inset-0 w-full'>
                        <div className='absolute inset-0 bg-gray-800 opacity-70 group-hover:opacity-50' />
                        <div className='absolute inset-0 flex items-center justify-center'>
                          <div className='text-white text-2xl group-hover:text-gray-50'>{`+${images.length > 0 && images.filter((image) => image.fileName !== '').length - Number(renderedImages)} Kép`}</div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
      </Masonry>
    </ResponsiveMasonry>
  );
};
